import { render, staticRenderFns } from "./ServiceEdit.vue?vue&type=template&id=4f2027e6&scoped=true"
import script from "./ServiceEdit.vue?vue&type=script&lang=js"
export * from "./ServiceEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceEdit.vue?vue&type=style&index=0&id=4f2027e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2027e6",
  null
  
)

export default component.exports